/**
 * Admin Page
 * 
 * Placeholder per PHASE_B_WORK_ORDERS.md B2.
 * Role-gated: admin or owner only.
 */

export default function AdminPage() {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-neutral-900">Admin</h1>
        <p className="mt-2 text-sm text-neutral-600">
          Route: /app/admin | Status: Authenticated | Access: Admin/Owner only
        </p>
      </div>
      
      <div className="bg-white border border-neutral-200 rounded-lg p-8 text-center">
        <p className="text-neutral-600">This feature is not yet available.</p>
      </div>
    </div>
  );
}
